export const formatarInscricaoFederal = (value) => {
    try {
        let valorFormatado = value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

        if (valorFormatado.length <= 11 && /^\d+$/.test(valorFormatado)) {
            // CPF: sempre numérico
            valorFormatado = valorFormatado
                .replace(/(\d{3})(\d)/, "$1.$2")
                .replace(/(\d{3})(\d)/, "$1.$2")
                .replace(/(\d{3})(\d{1,2})/, "$1-$2")
                .replace(/(-\d{2})\d+?$/, "$1");
        } else if (valorFormatado.length > 11) {
            // CNPJ: alfanumérico, dígitos verificadores sempre numéricos
            valorFormatado = valorFormatado
                .replace(/^(.{2})(.{3})(.{3})(.{4})(\d{2}).*$/, "$1.$2.$3/$4-$5");
        }

        return valorFormatado;
    } catch (error) {
        console.error(error);
        return value;
    }
}